import { IconName } from '@ben/orion/icon';
import { Modal, ModalVariant } from '@ben/orion/modals/modal';

import { memo } from 'react';

interface TimeFrameWarningModalProps {
  daysUntilRenewal: number;
  onClose: () => void;
  onConfirm: () => void;
}

const TimeFrameWarningModal = ({
  daysUntilRenewal,
  onClose,
  onConfirm,
}: TimeFrameWarningModalProps) => {
  return (
    <Modal
      isOpen={!!daysUntilRenewal}
      title={`Renewal start date in ${daysUntilRenewal} day${daysUntilRenewal === 1 ? '' : 's'}.`}
      description={`Are you sure you want to continue with these renewal details? \n You’ll have limited time to make any changes before they take effect.`}
      primaryText="Continue"
      secondaryText="Cancel"
      variant={ModalVariant.Icon}
      icon={IconName.Alert}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default memo(TimeFrameWarningModal);
